
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check"


// self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
export function initFirebase() {
  const firebaseConfig = {
    apiKey: "AIzaSyCbjeUzC4r4mzYh9eAbpasNb6wsIDQfGg4",
    authDomain: "platinum-auto-59a82.firebaseapp.com",
    projectId: "platinum-auto-59a82",
    storageBucket: "platinum-auto-59a82.appspot.com",
    messagingSenderId: "521194976275",
    appId: "1:521194976275:web:f72c33aa50cd325d413be6"
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6LfcKoEgAAAAAFBdzvkdD2EMs5BCVvBOJYr9iXFI'),
    isTokenAutoRefreshEnabled: true
  })
}